module.exports = __webpack_public_path__ + "static/V7_101_Gin-65d9efa357bd442dba2b48be20a5265b.jpg";